/* eslint-disable no-alert */
/* eslint-disable no-console */
import { register } from 'register-service-worker';

let registrationInstance = null;

export function initServiceWorker(store) {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(registration) {
      console.log(
        'App is being served from cache by a service worker.\n'
        + 'For more details, visit https://goo.gl/AFskqB',
      );
      registrationInstance = registration;
      
      if (registration) {
        registration.update();
      }
    },
    registered(registration) {
      console.log('Service worker has been registered.');
      registrationInstance = registration;
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading.');
    },
    updated(registration) {
      console.log('New content is available; please refresh.');
      registrationInstance = registration;
      store.commit('SET_SW_UPDATE_AVAILABLE', registration);
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });

  const checkForUpdates = () => {
    if (registrationInstance && document.visibilityState === 'visible') {
      registrationInstance.update();
    }
  };

  document.addEventListener('visibilitychange', checkForUpdates);
  window.addEventListener('focus', checkForUpdates);
}

export function getRegistration() {
  return registrationInstance;
}
